import session from '../auth_api/session'

export default {
  namespaced: true,
  state: {
    listLoading: [],
    errors: {}
  },
  mutations: {
    pushLoading (state, payload) {
      state.listLoading.push(payload)
    },
    popLoading (state, payload) {
      state.listLoading.splice(state.listLoading.indexOf(payload), 1)
    },
    setError: function (state, err) {
      let errors = {}
      if (typeof err === 'string') {
        state.errors = { 'Ошибка': [err] }
        return
      }
      if (typeof err === 'object') {
        if (err.hasOwnProperty('response') && !(err.response === undefined)) {
          if (err.response.status === 403) {
            state.errors = { 'Ошибка': ['Доступ запрещен.'] }
            if (err.response.hasOwnProperty('data') && err.response.data.hasOwnProperty('detail')) {
              const detail = err.response.data.detail
              state.errors = { 'Ошибка': ['Доступ запрещен.', detail] }
            }
            return
          }
          if (typeof err.response.data === 'string') {
            state.errors = { 'Ошибка': [err.message], 'Описание': [err.response.data] }
            return
          } else {
            for (let k in err.response.data) {
              if (typeof err.response.data[k] === 'string') {
                errors[k] = [err.response.data[k]]
              } else {
                errors[k] = err.response.data[k]
              }
            }
            state.errors = errors
            return
          }
        } else if (err.hasOwnProperty('message')) {
          const message = err.message
          state.errors = { 'Ошибка': [message] }
          return
        }
      }
      state.errors = { 'Ошибка': [''] }
    },
    clearError (state) {
      state.errors = {}
    }
  },
  actions: {
    pushLoading ({ commit }, payload) {
      commit('pushLoading', payload)
    },
    popLoading ({ commit }, payload) {
      commit('popLoading', payload)
    },
    setError ({ commit }, payload) {
      try {
        if (payload.response.status === 401) {
          commit('auth/removeToken', null, { root: true })
        } else {
          commit('setError', payload)
        }
      } catch (e) {
        commit('setError', payload)
      }
    },
    clearError ({ commit }) {
      commit('clearError')
    },
    downloadFile ({ commit, dispatch }, link) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadFile_' + link.urlFile
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = link.urlFile
        const download = require('js-file-download')
        session({ url: _url,
          method: 'GET',
          responseType: 'blob'
          // headers: {'X-Custom-Header': 'foobar'}
          // baseURL: 'http://127.0.0.1:8089',
          // header: {
          //   'Access-Control-Allow-Origin': '*'
          // }
        })
          .then(response => {
            download(response.data,
              link.filename,
              ('mime' in link) ? link.mime : 'application/octet-stream'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    listLoading (state) {
      return state.listLoading
    },
    errors (state) {
      return state.errors
    }
  }
}
